<template src="./reviews-list-utilities.html"></template>

<script lang="ts">
import { nextTick } from 'vue'
import bu from 'util/browser-utils'
import domUtils from 'util/dom-utils'
import launchWriteReview from 'util/launch-write-review'
import Listbox from 'objects/listbox/Listbox.vue'
import ReviewFilters from 'components/reviews-list/ReviewFilters.vue'
import reviewsListConfig from 'widgets/reviews-list/reviews-list-widget.config'
import reviewsStore from 'store/reviews-store'
import SearchField from 'objects/form/SearchField.vue'
import { SortOption } from 'services/api-service'
import submissionStore from 'store/submission-store'


export default {
  data() {
    return {
      filterStore: reviewsStore.filterStore,
      reviewsStore,
      submissionStoreState: submissionStore.state,
      toggleFiltersOn: false
    }
  },
  emits: ['searchText:focus'],
  components: {
    'tt-listbox': Listbox,
    'tt-review-filters': ReviewFilters,
    'tt-search-field': SearchField
  },
  computed: {
    appliedFilterOptions() {
      return this.filterStore.appliedFilters
    },
    hasSearchTerm() {
      return this.reviewsStore.trimmedSearchTerm.length > 0
    },
    hideWriteReview() {
      return reviewsListConfig.hideWriteReview
    },
    numFilters() {
      return this.filterStore.filters.filter((f) => !f.hidden).length
    },
    isLaunchingWriteReview() {
      return this.submissionStoreState.isLaunchingWriteReview
    },
    sortBy() {
      return this.reviewsStore.sort
    },
    sortField() {
      const sortBy = this.reviewsStore.sort
      return {
        model: sortBy,
        label: this.$msg(`reviewsList.sortBy.${sortBy}`),
        options: reviewsListConfig.sortOptions.map((option) => {
          return { value: option, label: this.$msg(`reviewsList.sortBy.${option}`) } as SortOption
        })
      }
    },
    showFilters() {
      return (this.showFiltersToggle && this.toggleFiltersOn) ||
        (!this.showFiltersToggle && this.numFilters > 1)
    },
    showFiltersToggle() {
      const isMobile = bu.isMobileDevice()
      return this.numFilters > 1 && (
        (reviewsListConfig.toggleFiltersDesktop && !isMobile) ||
        (reviewsListConfig.toggleFiltersMobile && isMobile)
      )
    },
    toggleFiltersText() {
      return this.$msg(this.toggleFiltersOn ? 'reviewsList.hideFilters' : 'reviewsList.showFilters')
    }
  },
  methods: {
    clearAllFilters() {
      this.filterStore.clearFilters()
      this.focusOnHeading()
    },
    filterItemSelected() {
      reviewsStore.updateAriaText = true
    },
    focusOnHeading() {
      nextTick(() => {
        // even with nextTick, the heading isn't always updated right away.  Delaying to give it
        // time to be updated before focusing so it reads the correct count
        setTimeout(() => {
          // not great to so tightly couple the class name, but simpler than firing event to focus
          domUtils.safeFocus(
            document.querySelector('#tt-reviews-list .tt-c-reviews-list__heading') as HTMLElement)
        }, 500)
      })
    },
    onSort(value: string) {
      reviewsStore.sort = value
    },
    removeFilter(filter, value) {
      const removingLastFilter = this.filterStore.appliedFilters.length === 1
      this.filterStore.removeFilterValue(filter, value)
      if (removingLastFilter) {
        this.focusOnHeading()
      } else {
        reviewsStore.updateAriaText = true
      }
    },
    toggleFilters() {
      this.toggleFiltersOn = !this.toggleFiltersOn
    },
    updateSearchText(text) {
      const updateAriaText = reviewsStore.trimmedSearchTerm !== text.trim()
      reviewsStore.searchTerm = text
      reviewsStore.updateAriaText = updateAriaText
    },
    searchTextFocus() {
      this.$emit('searchText:focus')
    },
    writeReview() {
      launchWriteReview()
    }
  }
}
</script>

<style lang="scss" src="./reviews-list-utilities.scss"></style>
